
      var _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGlobus = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 110,
  height: 135,
  viewBox: "0 0 75 93",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.5 48.567c4-1 29-4 12 13m1.5-53.5c-.333 2.5-2 7-.5 12.5 1.322 4.848 7 7.5 9 12s1.5 13 8 13c6.577 0 6-11.5 6-17s5-7.5 6-11.5 0-8-1-9.5",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 3,
  strokeLinecap: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 33.5,
  cy: 35.567,
  r: 31,
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 3,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5 70.174a38.831 38.831 0 0 0 18 4.393c21.54 0 39-17.46 39-39 0-14.64-8.068-27.397-20-34.067",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 3,
  strokeLinecap: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M33 83.567H21.5l-2 7h27l-2-7H33Zm0 0v-9",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg width=\"110\" height=\"135\" viewBox=\"0 0 75 93\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M5.5 48.5671C9.5 47.5671 34.5 44.5671 17.5 61.5671M19 8.06711C18.6667 10.5671 17 15.0671 18.5 20.5671C19.8221 25.415 25.5 28.0671 27.5 32.5671C29.5 37.0671 29 45.5671 35.5 45.5671C42.0765 45.5671 41.5 34.0671 41.5 28.5671C41.5 23.0671 46.5 21.0671 47.5 17.0671C48.5 13.0671 47.5 9.06711 46.5 7.56711\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"3\" stroke-linecap=\"round\"/>\r\n<circle cx=\"33.5\" cy=\"35.5671\" r=\"31\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"3\" stroke-linecap=\"round\"/>\r\n<path d=\"M15.5 70.1738C20.8851 72.9805 27.0072 74.5671 33.5 74.5671C55.0391 74.5671 72.5 57.1062 72.5 35.5671C72.5 20.9262 64.4323 8.16952 52.5 1.50027\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"3\" stroke-linecap=\"round\"/>\r\n<path d=\"M33 83.5671H21.5L19.5 90.5671H46.5L44.5 83.5671H33ZM33 83.5671V74.5671\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/globus.27d0c0183042298f2403b51cf96eed3a.svg"),
        {
          React: SvgGlobus,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      